import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ProjectSetupCResponse } from '@app/models/project-setup.models';

export interface SectionCFormGroup {
  riskFactors: FormControl<string>;
}

export function getSectionCFormGroup(
  fb: FormBuilder
): FormGroup<SectionCFormGroup> {
  return fb.nonNullable.group({
    riskFactors: fb.nonNullable.control<string>(''),
  });
}

export function getSectionCUpdateData(
  formGroup: FormGroup<SectionCFormGroup>
): ProjectSetupCResponse {
  return {
    riskFactors: formGroup.controls.riskFactors.value,
  };
}

export function patchSectionCForm(
  formGroup: FormGroup<SectionCFormGroup>,
  data: ProjectSetupCResponse
): void {
  formGroup.controls.riskFactors.setValue(data.riskFactors);
}
